import { DataCache, ForeignKeyRelationship, QueryResultsRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { PilotsNavbarCache } from '../pilotsheader/cache';
import { RotationDashboard } from 'data/models/RotationDashboard';

export class RotationDashboardCache extends DataCache {
    RotationDashboards = PCCollection(RotationDashboard);

    constructor(data : PCCache, navbarCache : PilotsNavbarCache) {
        super();

        new SharedKeyRelationship   (this.RotationDashboards, data.PilotAgencies, d => d.PilotAgency, null);
        new QueryResultsRelationship(this.RotationDashboards, data.Pilots,        d => d.Pilots);

        new ForeignKeyRelationship  (navbarCache.PilotsNavbars, this.RotationDashboards, null, d => d.Navbar, d => d.Id());
    }
}



// WEBPACK FOOTER //
// ./apps/pilots/rotationdashboard/cache.ts